import React from 'react'
import ReactDOM from 'react-dom'
import Topic from "../../../../../deprecated/assets/javascripts/shared/topic";
import { NotificationPreviewButton } from './Button'

export default class NotificationPreviewContainer {
  constructor({ element }) {
    this.element = element
  }

  getLoginData(data) {
    const isLoggedIn = Object.entries(data).length !== 0
    const token = isLoggedIn ? data.tokens.pns : ""
    return { isLoggedIn, token }
  }

  init() {
    if (window.currentUser) {
      const { isLoggedIn, token } = this.getLoginData(window.currentUser)
      ReactDOM.render(<NotificationPreviewButton isLoggedIn={isLoggedIn} token={token} />, this.element)
    } else {
      Topic.subscribeOnce('user/data/loaded', (data) => {
        const { isLoggedIn, token } = this.getLoginData(data)
        ReactDOM.render(<NotificationPreviewButton isLoggedIn={isLoggedIn} token={token} />, this.element)
      })
    }
  }
}